import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { Routes } from '@angular/router';
import { Main } from './main/main';
import {Test} from './test/test'; // Import du composant Main

export const routes: Routes = [
  { path: 'main', component: Main }, // Route pour le composant Main
  { path: 'test', component: Test }, // Route pour le composant Main
  { path: '',     component: Main   } // Default route - redirects to Main
];


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withFetch())
  ]
};
